// src/components/SimpleTable.jsx
import * as React from "react";
import { Box, Paper } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

export default function SimpleTable({
  rows = [],
  columns = [],
  getRowId,
  loading = false,
  checkboxSelection = false,
  pageSizeOptions = [5, 10, 25, 50, 100],
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
  filterModel,
  onFilterModelChange,
  serverSide = false,
  rowCount, // ← NEW: total rows in DB (for server mode)
  height = "75vh",
   sx,                      // <-- incoming sx for DataGrid (we will pass into DataGrid)
  getRowClassName
}) {
  const [localPagination, setLocalPagination] = React.useState({
    page: 0,
    pageSize: 10,
  });
  const [localSort, setLocalSort] = React.useState([]);
  const [localFilter, setLocalFilter] = React.useState({ items: [] });

  const pm = paginationModel ?? localPagination;
  const sm = sortModel ?? localSort;
  const fm = filterModel ?? localFilter;

  return (
    <Paper elevation={0} sx={{ p: 0, background: "transparent" }}>
      <Box sx={{ height, width: "100%", ...sx }}>
      <DataGrid
        rows={rows}
        rowCount={serverSide ? rowCount ?? 0 : undefined} 
        columns={columns}
        getRowId={getRowId}
        loading={loading}
        checkboxSelection={checkboxSelection}
        disableRowSelectionOnClick
        pageSizeOptions={pageSizeOptions}
        paginationModel={pm}
        onPaginationModelChange={onPaginationModelChange ?? setLocalPagination}
        sortModel={sm}
        onSortModelChange={onSortModelChange ?? setLocalSort}
        filterModel={fm}
        onFilterModelChange={onFilterModelChange ?? setLocalFilter}
        components={{ Toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 300 },
          },
        }}
        paginationMode={serverSide ? "server" : "client"}
        sortingMode={serverSide ? "server" : "client"}
        filterMode={serverSide ? "server" : "client"}
        initialState={{ pagination: { paginationModel: pm } }}

          /** ⭐ Override default messages */
  localeText={{
    noRowsLabel: "No data available",
    noResultsOverlayLabel: "No data available",
  }}
        /** ✅ Pass props correctly */
        sx={sx}
        getRowClassName={getRowClassName}
      />
      </Box>
    </Paper>
  );
}
